module.exports = __webpack_public_path__ + "img/voice_nav.73cd65d9.png";